module.exports = "/bundle/Nationale-Bold.woff2";